import Vue from 'vue';
import App from '../components/App';
import Toast from '../components/common/Toast';
import '../style/normalize.css';
import { dfImg } from 'JS/img';

import { setPBName } from 'UTILS/Axios.js';
import jsonName from '../pb/index.min.json';
// 传入数据启用模拟数据
setPBName(jsonName);

Vue.prototype.$toast = Toast;
// 默认头像
Vue.prototype.$defAvatar = dfImg('avatar');

new Vue({
  el: '#comment_module',
  components: {App},
  template: '<App/>'
});
